export const CONTACT = {
  email: "marina@marinaknows.com",
  phoneDisplay: "+34 650 20 89 27",
  phoneRaw: "+34650208927",
  whatsapp: "https://wa.me/34650208927",
};

export const IMAGES = {
  hero: "/images/scene-hero.jpg",
  pano: "/images/scene-pano.jpg",
  area: "/images/scene-area.jpg",
  marina: "/images/marina-main.jpg",
  marina2: "/images/marina-candid.jpg",
  coast:
    "https://images.unsplash.com/photo-1779620505744-9d40f520dbfc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const translations = {
  en: {
    ui: { chatTooltip: "Shall we chat?" },
    promo: {
      text: "New client offer: 50% off all services booked in September.",
      valid: "Valid through September 30",
      endsIn: "Ends in",
      days: "d",
      hours: "h",
      mins: "m",
      secs: "s",
      cta: "Claim it",
    },
    nav: {
      home: "Home",
      about: "About Marina",
      services: "Services",
      pricing: "Pricing",
      faq: "FAQ",
      blog: "Blog",
      contact: "Contact",
      cta: "Message me",
    },
    hero: {
      overline: "Marina Knows · Comunidad Valenciana",
      lines: ["Bureaucracy in Spain,", "handled with care,", "in your language."],
      sub: "15 years helping people navigate Spain — NIE, TIE, empadronamiento, translations and everything in between. You don't have to do this alone, or in a language you don't understand. I'll walk you through it.",
      ctaPrimary: "Message me on WhatsApp",
      ctaSecondary: "See services & prices",
      badge: "15 years helping people navigate Spain",
    },
    quiz: {
      overline: "The exciting bit",
      title: "So… you're moving to Spain?!",
      sub: "Four quick questions and I'll come back with a plan and a fixed price. This is the fun part — promise.",
      s1q: "Where are you on the adventure?",
      s1: [
        { label: "Still daydreaming", sub: "Beach tabs open, spreadsheet not yet" },
        { label: "Planning the move", sub: "Lists everywhere, flights not booked" },
        { label: "Just landed!", sub: "Suitcase barely unpacked" },
        { label: "Here & happily stuck", sub: "Love it — but the paperwork…" },
      ],
      s2q: "What shall we conquer first? Pick anything.",
      s2: ["NIE or TIE", "Empadronamiento", "Residency / visa", "Autónomo registration", "Translation / interpretation", "Housing & utilities", "Banking & taxes", "Healthcare", "Schools & family", "Honestly? Everything."],
      s3q: "Big question — when do you need it?",
      s3: [
        { label: "Yesterday. Help.", sub: "Something's on fire" },
        { label: "Within a month", sub: "The countdown is on" },
        { label: "Next 1–3 months", sub: "Comfortably organised" },
        { label: "No rush", sub: "Savouring the dream" },
      ],
      s4q: "Last one — where do I send the plan?",
      cheer: ["Love it — three to go.", "Great picks. Two left.", "Nearly there…", ""],
      name: "Your name",
      contact: "Email or WhatsApp number",
      message: "Anything else I should know? (optional)",
      back: "Back",
      next: "Next",
      submit: "Send it to Marina",
      successTitle: "¡Bienvenido! You're on your way.",
      successBody: "Your answers just landed with me — I'll reply personally within a day. Too excited to wait?",
      successCta: "Say hi on WhatsApp",
      errRequired: "Please add your name and a way to reach you.",
      errSend: "That didn't send — sorry! Try WhatsApp instead:",
      stepLabel: "of 4",
    },
    admin: {
      title: "Leads",
      passcode: "Passcode",
      unlock: "View leads",
      wrong: "Wrong passcode.",
      empty: "No leads yet.",
      name: "Name",
      contact: "Contact",
      situation: "Situation",
      needs: "Needs",
      timeline: "Timeline",
      message: "Message",
    },
    marquee: [
      "NIE appointments",
      "Empadronamiento",
      "TIE support",
      "Autónomo registration",
      "Translation & interpretation",
      "Bank accounts",
      "Tarjeta sanitaria",
      "School enrolment",
      "Residency applications",
    ],
    home: {
      ch1: "[ 01 ]",
      servicesOverline: "What I can take off your plate",
      servicesTitle: "One person, every office.",
      servicesSub: "From your first NIE appointment to your child's school enrolment — you deal with me, I deal with the paperwork.",
      servicesCta: "Full list & prices",
      categories: [
        { title: "Paperwork & appointments", desc: "NIE, TIE, empadronamiento, social security, cita previa booking — booked, prepared and accompanied.", price: "from €35" },
        { title: "Translation & interpretation", desc: "Professional document translation and live interpretation for your appointments.", price: "from €35" },
        { title: "Housing", desc: "Rental contract review and translation, utility setup, so you know exactly what you're signing.", price: "from €40" },
        { title: "Banking & finance", desc: "Bank account opening, tax system orientation and liaison with your gestor or accountant.", price: "from €45" },
        { title: "Healthcare", desc: "Public health card (tarjeta sanitaria) registration and English-speaking doctor sourcing.", price: "from €30" },
        { title: "Family & schools", desc: "School enrolment assistance and homologación (qualification recognition) guidance.", price: "from €70" },
      ],
      ch2: "[ 02 ]",
      whyOverline: "Why Marina",
      whyTitle: "A knowledgeable friend, not a faceless agency.",
      whyBody1: "I've spent 15 years inside Spain's offices, appointment systems and forms — first in tourism and administration, now entirely for people like you. I know which window to go to, which document they actually want, and how to ask for it in a way that gets a yes.",
      whyBody2: "You'll always know what's happening, what it costs, and what comes next. Plain language, no surprises.",
      whyPoints: [
        "15 years of hands-on experience in Spain",
        "Native Spanish, fluent English (C2) — plus working Italian, German and French",
        "Fixed, transparent prices agreed before we start",
        "Based in Valencia, working across the whole Comunidad Valenciana — and online, Spain-wide",
      ],
      whyCta: "More about me",
      packagesOverline: "Best value",
      packagesTitle: "Bundles for your first months",
      pkg1Name: "First 90 Days in Spain",
      pkg1Desc: "NIE/TIE support + empadronamiento + bank account + health card. The whole landing, one fixed price.",
      pkg1Price: "€350",
      pkg1Note: "vs ~€450 à la carte",
      pkg2Name: "Settling In — retainer",
      pkg2Desc: "Your ongoing point of contact for 3 months. Up to 5 hours of support per month for whatever comes up.",
      pkg2Price: "€300/month",
      pkg2Note: "3-month engagement",
      pkgCta: "See pricing",
      testimonialsOverline: "Kind words",
      testimonialsTitle: "What clients say",
      testimonialsNote: "Real client testimonials are being collected — these placeholders show how they'll appear.",
      testimonials: [
        { quote: "Marina turned two months of confusion into one calm afternoon. Worth every euro.", name: "Client placeholder", detail: "NIE + empadronamiento, Valencia" },
        { quote: "She sat with me at the appointment and translated everything. I finally understood what I was signing.", name: "Client placeholder", detail: "TIE appointment, Alicante" },
        { quote: "The First 90 Days package paid for itself in stress I didn't have.", name: "Client placeholder", detail: "Relocation package, Xàbia" },
      ],
      ch3: "[ 03 ]",
      areaOverline: "Where I work",
      areaTitle: "Comunidad Valenciana, in person. All of Spain, online.",
      areaSub: "Based in Valencia city, regularly on the ground in the region's expat hubs — and a video call away for everything else.",
      areas: ["Valencia city", "Alicante", "Xàbia / Jávea", "Dénia", "Gandía", "Castellón", "Spain-wide (remote)"],
      ctaTitle: "Tell me what you're stuck on.",
      ctaSub: "A short WhatsApp message is all it takes. I'll reply with a plan and a fixed price — no obligation.",
      ctaButton: "Start on WhatsApp",
    },
    about: {
      overline: "About Marina",
      title: "Hola, I'm Marina.",
      lead: "Fifteen years ago I helped my first lost foreigner fill in a form at a Valencia police station. I've been doing it ever since — and I still love the look on someone's face when the stamp finally lands.",
      body1: "My background is in tourism, hospitality and administration — years of coordinating people, suppliers and paperwork in cultural and corporate environments across Spain. Along the way I became the person friends called when the Spanish system said no, or nothing at all. At some point I realised that was the work itself.",
      body2: "Today I work one-to-one with people moving to the Comunidad Valenciana: booking the appointments nobody can find, translating the letters nobody can read, and sitting next to you at the offices nobody wants to visit alone.",
      body3: "I'm not a gestoría and I'm not a law firm. I'm the knowledgeable friend who has done this hundreds of times — and when your case genuinely needs a lawyer, a gestor or an accredited sworn translator, I'll tell you and point you to one I trust.",
      expTitle: "15",
      expYears: "years of experience",
      langTitle: "Languages",
      langs: [
        { lang: "Spanish", level: "Native" },
        { lang: "English", level: "Fluent — C2 certified" },
        { lang: "Italian · German · French", level: "Working knowledge" },
      ],
      trustTitle: "How I work",
      trust: [
        "Fixed prices agreed in writing before we start",
        "You get plain-language updates at every step",
        "I never submit anything you haven't seen and approved",
        "If I can't help, I say so — and refer you to someone who can",
      ],
      photoAlt: "Marina, founder of Marina Knows, in Valencia",
      cta: "Say hola",
    },
    servicesPage: {
      overline: "Services",
      title: "Everything between you and settled.",
      sub: "Fixed, transparent prices — agreed before we start, no surprises after. All services available in person across the Comunidad Valenciana and online throughout Spain.",
      swornTitle: "A note on sworn translation",
      swornBody: "I provide professional translation and interpretation, but I am not an accredited sworn translator (Traductora-Intérprete Jurada). Some documents — for example birth certificates for official registry use — legally require a sworn translation. When that's the case, I'll tell you honestly and connect you with an accredited colleague.",
      perPage: "per page (up to ~250 words)",
      perWord: "per word beyond the first page",
      perHour: "per hour (1 hr minimum)",
      perUtility: "per utility",
      from: "from",
      cta: "Book via WhatsApp",
      groups: [
        {
          name: "Paperwork & bureaucracy",
          items: [
            { name: "NIE application support", desc: "Appointment booking, document preparation and accompaniment on the day.", price: "€120" },
            { name: "TIE application support", desc: "Full process for non-EU residents, from forms to fingerprinting.", price: "€180" },
            { name: "Empadronamiento registration", desc: "Town hall registration done right the first time.", price: "€60" },
            { name: "Social Security number", desc: "Registration and confirmation of your número de la seguridad social.", price: "€60" },
            { name: "Autónomo registration (alta)", desc: "Set up as self-employed, step by step.", price: "€150" },
            { name: "Autónomo deregistration (baja)", desc: "Close your autónomo activity cleanly.", price: "€80" },
            { name: "Residency application support", desc: "Non-lucrative, digital nomad or student — priced per type after a quick chat.", price: "from €250" },
            { name: "Driving licence exchange (canje)", desc: "Swap your licence for a Spanish one without the maze.", price: "€90" },
            { name: "Cita previa booking only", desc: "I find and book the appointment for any of the above; you take it from there.", price: "€35" },
          ],
        },
        {
          name: "Translation & interpretation",
          items: [
            { name: "Standard document translation", desc: "Contracts, letters, certificates and everyday documents.", price: "€35", unit: "perPage" },
            { name: "Additional words", desc: "Beyond the first page.", price: "€0.15", unit: "perWord" },
            { name: "Live interpretation", desc: "I come with you — offices, doctors, schools, notaries.", price: "€50", unit: "perHour" },
            { name: "Interpretation half-day", desc: "Up to 4 hours for longer days of appointments.", price: "€160" },
          ],
        },
        {
          name: "Housing",
          items: [
            { name: "Rental contract review & translation", desc: "Know exactly what you're signing, before you sign it.", price: "€80" },
            { name: "Utility setup assistance", desc: "Electricity, water, gas, internet — set up and in your name.", price: "€40", unit: "perUtility" },
          ],
        },
        {
          name: "Banking & finance",
          items: [
            { name: "Bank account opening", desc: "The right bank, the right documents, accompanied if needed.", price: "€70" },
            { name: "Tax system orientation session", desc: "One hour to understand what applies to you. No formal tax filing or advice.", price: "€50" },
            { name: "Gestor / accountant liaison", desc: "I translate and coordinate between you and your gestor.", price: "€45", unit: "perHour" },
          ],
        },
        {
          name: "Healthcare",
          items: [
            { name: "Public health registration", desc: "Your tarjeta sanitaria and health centre assignment.", price: "€50" },
            { name: "English-speaking doctor sourcing", desc: "Find and book a doctor you can actually talk to.", price: "€30" },
          ],
        },
        {
          name: "Family",
          items: [
            { name: "School enrolment assistance", desc: "Options, paperwork and deadlines for public and concertado schools.", price: "€70" },
            { name: "Homologación guidance", desc: "Recognition of foreign qualifications — complexity varies, so we scope it first.", price: "from €150" },
          ],
        },
      ],
    },
    pricingPage: {
      overline: "Pricing",
      title: "Clear prices, agreed before we start.",
      sub: "No hourly creep, no surprise invoices. You approve the scope and the price in writing before anything happens.",
      promoTitle: "September welcome offer",
      promoText: "50% off all services booked in September — my way of saying bienvenido.",
      promoValid: "Valid for bookings made through September 30. Discount applies to all services and packages.",
      packagesTitle: "Packages — best value",
      alaCarteTitle: "À la carte",
      pkg1Name: "First 90 Days in Spain",
      pkg1Desc: "The complete landing: NIE or TIE support, empadronamiento, bank account and health card. One fixed price, one person handling it all.",
      pkg1Includes: ["NIE or TIE application support", "Empadronamiento registration", "Bank account opening", "Tarjeta sanitaria registration"],
      pkg1Price: "€350",
      pkg1Note: "vs ~€450 à la carte — save ~€100",
      pkg2Name: "Settling In — retainer",
      pkg2Desc: "Three months of having me on call. Up to 5 hours of support each month for whatever Spain throws at you — letters, calls, appointments, translations.",
      pkg2Includes: ["Up to 5 hours support / month", "Priority WhatsApp replies", "Document translation included", "Appointment accompaniment included"],
      pkg2Price: "€300",
      pkg2Note: "per month · 3-month engagement",
      cta: "Book now — September offer",
      bookCta: "Book this",
      bestValue: "Best value",
      tableHeaders: { service: "Service", price: "Price" },
    },
    faqPage: {
      overline: "FAQ",
      title: "The questions everyone asks.",
      sub: "Straight answers in plain language. If yours isn't here, just ask me directly.",
      items: [
        { q: "How long does it take to get a NIE in Valencia?", a: "The NIE number itself is usually assigned at your appointment or within a few days. The real bottleneck is the cita previa (appointment) — in Valencia these can take anywhere from a few days to several weeks to find, depending on the office and time of year. Booking early and checking the right offices makes a big difference, which is exactly what I do for you." },
        { q: "Do I need empadronamiento before opening a bank account?", a: "Not always. Some banks will open a non-resident account with just your passport and NIE. However, the empadronamiento certificate makes everything smoother — banks, health registration and school enrolment all ask for it — so I usually recommend doing it early. It's quick when the paperwork is right." },
        { q: "What's the difference between the NIE and the TIE?", a: "The NIE is just a number — your foreigner identification number, used for taxes, contracts and admin. The TIE is the physical residence card for non-EU citizens staying long-term; it contains your NIE plus your photo, fingerprints and permit type. EU citizens typically get the green certificate instead. I handle both processes." },
        { q: "Can you book my cita previa for me?", a: "Yes — it's one of my most requested services (€35). Appointments for police, extranjería and town halls in Valencia disappear within minutes of being released. I monitor the system and grab one for you, then send you the confirmation and exactly what to bring." },
        { q: "Do you offer sworn translation (traducción jurada)?", a: "No — I'm a professional translator and interpreter, not an accredited sworn translator (Traductora-Intérprete Jurada). Documents like birth certificates for official registry use legally require a sworn translation, and for those I'll connect you with an accredited colleague I trust. For everything else — contracts, letters, everyday documents and live interpretation — I can help directly." },
        { q: "Do I have to be in Valencia to work with you?", a: "No. I work in person across the Comunidad Valenciana — Valencia city, Alicante, Xàbia/Jávea, Dénia, Gandía and surroundings — and remotely with clients all over Spain. Many things (document prep, translation, booking appointments) can be done entirely online." },
        { q: "How does the September offer work?", a: "Any service booked before September 30 gets 50% off the listed price — including the packages. Message me on WhatsApp or through the contact form, mention the offer, and I'll confirm your discounted price in writing before we start." },
        { q: "What documents do I need for empadronamiento in Valencia?", a: "Typically your passport, your NIE (if you have one), and proof of address — a rental contract or a signed authorisation from the property owner plus their documents. Requirements vary slightly by town hall, so I check the exact list for your address before we go." },
        { q: "Can you help me register as autónomo in Spain?", a: "Yes. The alta involves registering with both the tax office (Hacienda) and Social Security, choosing the right activity code, and understanding your quota options — including the reduced rate for new autónomos. The full setup is €150, and I can also coordinate with a gestor for your ongoing filings if you want one." },
        { q: "Is this legal or tax advice?", a: "No. I help you navigate procedures, prepare documents and communicate with offices. For formal legal or tax advice I'll refer you to a lawyer or gestor I trust — and I'll translate and coordinate with them so nothing gets lost." },
      ],
      cta: "Ask me directly",
    },
    contactPage: {
      overline: "Contact",
      title: "Let's sort it out.",
      sub: "WhatsApp is fastest — I usually reply within a few hours. Or send the form and I'll get back to you by email.",
      whatsapp: "WhatsApp (preferred)",
      emailLabel: "Email",
      phoneLabel: "Phone",
      areaTitle: "Service area",
      areaSub: "In person across the Comunidad Valenciana · online throughout Spain",
      form: {
        name: "Your name",
        email: "Your email",
        topic: "What do you need help with?",
        message: "Tell me a little about your situation",
        messagePlaceholder: "e.g. I've just arrived in Valencia and need my NIE and empadronamiento…",
        topics: ["NIE / TIE / residency", "Empadronamiento / social security", "Autónomo registration", "Translation / interpretation", "Housing / utilities", "Banking / taxes", "Healthcare", "Schools / family", "A package", "Something else"],
        sendEmail: "Send by email",
        sendWhatsapp: "Send via WhatsApp",
        note: "The form opens your email app or WhatsApp with your message ready — nothing is stored on this site.",
        nameRequired: "Please add your name and message first.",
      },
    },
    blog: {
      overline: "Blog",
      title: "Notes on navigating Spain.",
      sub: "Plain-language walkthroughs of the processes I handle every week — new guides added regularly.",
      soon: "Coming soon",
      topics: [
        { title: "NIE in Valencia: the complete 2026 walkthrough", tag: "Paperwork" },
        { title: "Empadronamiento: what it is and why everything asks for it", tag: "Settling in" },
        { title: "NIE vs TIE vs green certificate — which one are you?", tag: "Residency" },
        { title: "Autónomo in Spain: the first 30 days, step by step", tag: "Working" },
        { title: "How cita previa really works (and how to actually get one)", tag: "Paperwork" },
        { title: "Renting in Valencia: what your contract is really saying", tag: "Housing" },
      ],
      cta: "Get notified via WhatsApp",
    },
    footer: {
      tagline: "Bureaucracy in Spain, handled with care — in your language.",
      nav: "Explore",
      contactTitle: "Contact",
      area: "Valencia · Comunidad Valenciana · Spain-wide online",
      rights: "All rights reserved.",
      madeIn: "Valencia, Spain",
    },
  },

  es: {
    ui: { chatTooltip: "¿Hablamos?" },
    promo: {
      text: "Oferta de bienvenida: 50% de descuento en todos los servicios reservados en septiembre.",
      valid: "Válido hasta el 30 de septiembre",
      endsIn: "Termina en",
      days: "d",
      hours: "h",
      mins: "m",
      secs: "s",
      cta: "Aprovecharla",
    },
    nav: {
      home: "Inicio",
      about: "Sobre Marina",
      services: "Servicios",
      pricing: "Precios",
      faq: "Preguntas",
      blog: "Blog",
      contact: "Contacto",
      cta: "Escríbeme",
    },
    hero: {
      overline: "Marina Knows · Comunidad Valenciana",
      lines: ["La burocracia en España,", "resuelta con calma,", "en tu idioma."],
      sub: "15 años ayudando a personas a instalarse en España: NIE, TIE, empadronamiento, traducciones y todo lo demás. No tienes que hacerlo solo, ni en un idioma que no entiendas. Te acompaño paso a paso.",
      ctaPrimary: "Escríbeme por WhatsApp",
      ctaSecondary: "Ver servicios y precios",
      badge: "15 años ayudando a la gente a moverse por España",
    },
    quiz: {
      overline: "La parte emocionante",
      title: "¿Que te mudas a España? ¡Qué ilusión!",
      sub: "Cuatro preguntas rápidas y vuelvo con un plan y un precio fijo. Esta es la parte divertida, lo prometo.",
      s1q: "¿En qué punto de la aventura estás?",
      s1: [
        { label: "Soñando despierto/a", sub: "Pestañas de playas abiertas, Excel aún no" },
        { label: "Planeando la mudanza", sub: "Listas por todas partes, vuelos sin comprar" },
        { label: "¡Acabo de aterrizar!", sub: "La maleta casi sin deshacer" },
        { label: "Aquí y felizmente atascado/a", sub: "Encantado/a — pero el papeleo…" },
      ],
      s2q: "¿Qué conquistamos primero? Elige lo que quieras.",
      s2: ["NIE o TIE", "Empadronamiento", "Residencia / visado", "Alta de autónomo", "Traducción / interpretación", "Vivienda y suministros", "Banca e impuestos", "Salud", "Colegios y familia", "¿Sinceramente? Todo."],
      s3q: "La gran pregunta: ¿para cuándo lo necesitas?",
      s3: [
        { label: "Para ayer. Socorro.", sub: "Algo está ardiendo" },
        { label: "Dentro de un mes", sub: "La cuenta atrás ha empezado" },
        { label: "En 1–3 meses", sub: "Con tiempo y organización" },
        { label: "Sin prisa", sub: "Saboreando el sueño" },
      ],
      s4q: "La última: ¿dónde te envío el plan?",
      cheer: ["Me encanta — quedan tres.", "Buen gusto. Quedan dos.", "Ya casi está…", ""],
      name: "Tu nombre",
      contact: "Email o número de WhatsApp",
      message: "¿Algo más que deba saber? (opcional)",
      back: "Atrás",
      next: "Siguiente",
      submit: "Enviárselo a Marina",
      successTitle: "¡Bienvenido/a! Ya estás en camino.",
      successBody: "Tus respuestas acaban de llegarme — te respondo personalmente en un día. ¿Demasiada ilusión para esperar?",
      successCta: "Salúdame por WhatsApp",
      errRequired: "Añade tu nombre y una forma de contactarte, por favor.",
      errSend: "No se ha podido enviar — ¡perdón! Prueba por WhatsApp:",
      stepLabel: "de 4",
    },
    admin: {
      title: "Solicitudes",
      passcode: "Contraseña",
      unlock: "Ver solicitudes",
      wrong: "Contraseña incorrecta.",
      empty: "Aún no hay solicitudes.",
      name: "Nombre",
      contact: "Contacto",
      situation: "Situación",
      needs: "Necesita",
      timeline: "Plazo",
      message: "Mensaje",
    },
    marquee: [
      "Citas para el NIE",
      "Empadronamiento",
      "Trámites del TIE",
      "Alta de autónomos",
      "Traducción e interpretación",
      "Cuentas bancarias",
      "Tarjeta sanitaria",
      "Matrículas escolares",
      "Solicitudes de residencia",
    ],
    home: {
      ch1: "[ 01 ]",
      servicesOverline: "Lo que puedo quitar de tu lista",
      servicesTitle: "Una sola persona, todas las oficinas.",
      servicesSub: "Desde tu primera cita para el NIE hasta la matrícula del colegio de tus hijos: tú hablas conmigo, yo me encargo del papeleo.",
      servicesCta: "Lista completa y precios",
      categories: [
        { title: "Trámites y citas", desc: "NIE, TIE, empadronamiento, seguridad social y citas previas: reservadas, preparadas y acompañadas.", price: "desde 35 €" },
        { title: "Traducción e interpretación", desc: "Traducción profesional de documentos e interpretación en persona para tus citas.", price: "desde 35 €" },
        { title: "Vivienda", desc: "Revisión y traducción de contratos de alquiler y altas de suministros, para que sepas exactamente lo que firmas.", price: "desde 40 €" },
        { title: "Banca y finanzas", desc: "Apertura de cuentas bancarias, orientación fiscal y comunicación con tu gestor o asesor.", price: "desde 45 €" },
        { title: "Salud", desc: "Alta en la sanidad pública (tarjeta sanitaria) y búsqueda de médicos que hablen inglés.", price: "desde 30 €" },
        { title: "Familia y colegios", desc: "Ayuda con matrículas escolares y orientación sobre homologación de títulos.", price: "desde 70 €" },
      ],
      ch2: "[ 02 ]",
      whyOverline: "Por qué Marina",
      whyTitle: "Una amiga que sabe, no una agencia sin rostro.",
      whyBody1: "Llevo 15 años dentro de las oficinas, los sistemas de cita previa y los formularios de España — primero en turismo y administración, ahora por completo para personas como tú. Sé a qué ventanilla ir, qué documento quieren de verdad y cómo pedirlo para que la respuesta sea un sí.",
      whyBody2: "Siempre sabrás qué está pasando, cuánto cuesta y qué viene después. Lenguaje claro, sin sorpresas.",
      whyPoints: [
        "15 años de experiencia práctica en España",
        "Español nativo, inglés fluido (C2) — además de italiano, alemán y francés",
        "Precios fijos y transparentes, acordados antes de empezar",
        "Con base en Valencia, en toda la Comunidad Valenciana — y online para toda España",
      ],
      whyCta: "Más sobre mí",
      packagesOverline: "Mejor valor",
      packagesTitle: "Packs para tus primeros meses",
      pkg1Name: "Primeros 90 días en España",
      pkg1Desc: "NIE/TIE + empadronamiento + cuenta bancaria + tarjeta sanitaria. Todo el aterrizaje, un solo precio fijo.",
      pkg1Price: "350 €",
      pkg1Note: "frente a ~450 € por separado",
      pkg2Name: "Instalándote — retainer",
      pkg2Desc: "Tu persona de contacto durante 3 meses. Hasta 5 horas de apoyo al mes para lo que vaya surgiendo.",
      pkg2Price: "300 €/mes",
      pkg2Note: "compromiso de 3 meses",
      pkgCta: "Ver precios",
      testimonialsOverline: "Palabras bonitas",
      testimonialsTitle: "Lo que dicen los clientes",
      testimonialsNote: "Estoy recopilando testimonios reales — estos ejemplos muestran cómo aparecerán.",
      testimonials: [
        { quote: "Marina convirtió dos meses de caos en una tarde tranquila. Vale cada euro.", name: "Testimonio de ejemplo", detail: "NIE + empadronamiento, Valencia" },
        { quote: "Se sentó conmigo en la cita y lo tradujo todo. Por fin entendí lo que estaba firmando.", name: "Testimonio de ejemplo", detail: "Cita del TIE, Alicante" },
        { quote: "El pack de los primeros 90 días se pagó solo con el estrés que me ahorré.", name: "Testimonio de ejemplo", detail: "Pack de relocación, Xàbia" },
      ],
      ch3: "[ 03 ]",
      areaOverline: "Dónde trabajo",
      areaTitle: "Comunidad Valenciana, en persona. Toda España, online.",
      areaSub: "Con base en la ciudad de Valencia, presente con frecuencia en los núcleos de expatriados de la región — y a una videollamada para todo lo demás.",
      areas: ["Valencia capital", "Alicante", "Xàbia / Jávea", "Dénia", "Gandía", "Castellón", "Toda España (online)"],
      ctaTitle: "Cuéntame en qué te has atascado.",
      ctaSub: "Un mensaje corto por WhatsApp es suficiente. Te respondo con un plan y un precio fijo, sin compromiso.",
      ctaButton: "Empezar por WhatsApp",
    },
    about: {
      overline: "Sobre Marina",
      title: "Hola, soy Marina.",
      lead: "Hace quince años ayudé a mi primer extranjero perdido a rellenar un formulario en una comisaría de Valencia. Llevo haciéndolo desde entonces — y todavía me encanta la cara que pone la gente cuando por fin llega el sello.",
      body1: "Vengo del turismo, la hostelería y la administración: años coordinando personas, proveedores y papeleo en entornos culturales y empresariales por toda España. Por el camino me convertí en la persona a la que los amigos llamaban cuando el sistema español decía que no, o no decía nada. En algún momento entendí que eso era el trabajo en sí.",
      body2: "Hoy trabajo persona a persona con quienes se mudan a la Comunidad Valenciana: consiguiendo las citas que nadie encuentra, traduciendo las cartas que nadie entiende y sentándome a tu lado en las oficinas que nadie quiere visitar solo.",
      body3: "No soy una gestoría ni un bufete de abogados. Soy esa amiga que lo ha hecho cientos de veces — y cuando tu caso necesita de verdad un abogado, un gestor o un traductor jurado, te lo diré y te recomendaré a alguien de confianza.",
      expTitle: "15",
      expYears: "años de experiencia",
      langTitle: "Idiomas",
      langs: [
        { lang: "Español", level: "Nativo" },
        { lang: "Inglés", level: "Fluido — certificado C2" },
        { lang: "Italiano · Alemán · Francés", level: "Nivel de trabajo" },
      ],
      trustTitle: "Cómo trabajo",
      trust: [
        "Precios fijos acordados por escrito antes de empezar",
        "Te cuento cada paso en lenguaje claro",
        "Nunca presento nada que no hayas visto y aprobado",
        "Si no puedo ayudarte, te lo digo — y te derivo con quien sí puede",
      ],
      photoAlt: "Marina, fundadora de Marina Knows, en Valencia",
      cta: "Salúdame",
    },
    servicesPage: {
      overline: "Servicios",
      title: "Todo lo que hay entre tú y estar instalado.",
      sub: "Precios fijos y transparentes — acordados antes de empezar, sin sorpresas después. Todos los servicios presenciales en la Comunidad Valenciana y online en toda España.",
      swornTitle: "Una nota sobre la traducción jurada",
      swornBody: "Ofrezco traducción e interpretación profesional, pero no soy traductora jurada acreditada (Traductora-Intérprete Jurada). Algunos documentos — por ejemplo, certificados de nacimiento para uso oficial en registros — requieren por ley una traducción jurada. Cuando sea tu caso, te lo diré con honestidad y te pondré en contacto con una colega acreditada.",
      perPage: "por página (hasta ~250 palabras)",
      perWord: "por palabra a partir de la segunda página",
      perHour: "por hora (mínimo 1 h)",
      perUtility: "por suministro",
      from: "desde",
      cta: "Reservar por WhatsApp",
      groups: [
        {
          name: "Trámites y burocracia",
          items: [
            { name: "Apoyo para el NIE", desc: "Reserva de cita, preparación de documentos y acompañamiento el día de la cita.", price: "120 €" },
            { name: "Apoyo para el TIE", desc: "Proceso completo para residentes no comunitarios, de los formularios a la toma de huellas.", price: "180 €" },
            { name: "Empadronamiento", desc: "Alta en el padrón municipal bien hecha a la primera.", price: "60 €" },
            { name: "Número de la Seguridad Social", desc: "Alta y confirmación de tu número de afiliación.", price: "60 €" },
            { name: "Alta de autónomo", desc: "Date de alta como trabajador por cuenta propia, paso a paso.", price: "150 €" },
            { name: "Baja de autónomo", desc: "Cierra tu actividad de autónomo sin cabos sueltos.", price: "80 €" },
            { name: "Apoyo en solicitud de residencia", desc: "No lucrativa, nómada digital o estudiante — precio según tipo tras una breve charla.", price: "desde 250 €" },
            { name: "Canje del permiso de conducir", desc: "Cambia tu carnet por el español sin perderte en el laberinto.", price: "90 €" },
            { name: "Solo cita previa", desc: "Encuentro y reservo la cita de cualquiera de los trámites anteriores; tú sigues desde ahí.", price: "35 €" },
          ],
        },
        {
          name: "Traducción e interpretación",
          items: [
            { name: "Traducción estándar de documentos", desc: "Contratos, cartas, certificados y documentos del día a día.", price: "35 €", unit: "perPage" },
            { name: "Palabras adicionales", desc: "A partir de la primera página.", price: "0,15 €", unit: "perWord" },
            { name: "Interpretación en persona", desc: "Te acompaño: oficinas, médicos, colegios, notarías.", price: "50 €", unit: "perHour" },
            { name: "Media jornada de interpretación", desc: "Hasta 4 horas para días largos de citas.", price: "160 €" },
          ],
        },
        {
          name: "Vivienda",
          items: [
            { name: "Revisión y traducción de contrato de alquiler", desc: "Sabe exactamente lo que firmas, antes de firmarlo.", price: "80 €" },
            { name: "Alta de suministros", desc: "Luz, agua, gas, internet — dados de alta y a tu nombre.", price: "40 €", unit: "perUtility" },
          ],
        },
        {
          name: "Banca y finanzas",
          items: [
            { name: "Apertura de cuenta bancaria", desc: "El banco adecuado, los documentos correctos, con acompañamiento si lo necesitas.", price: "70 €" },
            { name: "Sesión de orientación fiscal", desc: "Una hora para entender qué te aplica. Sin declaraciones ni asesoramiento fiscal formal.", price: "50 €" },
            { name: "Enlace con tu gestor / asesor", desc: "Traduzco y coordino entre tú y tu gestoría.", price: "45 €", unit: "perHour" },
          ],
        },
        {
          name: "Salud",
          items: [
            { name: "Alta en la sanidad pública", desc: "Tu tarjeta sanitaria y la asignación de tu centro de salud.", price: "50 €" },
            { name: "Búsqueda de médico en inglés", desc: "Encuentra y reserva con un médico con el que puedas hablar de verdad.", price: "30 €" },
          ],
        },
        {
          name: "Familia",
          items: [
            { name: "Ayuda con la matrícula escolar", desc: "Opciones, papeleo y plazos para colegios públicos y concertados.", price: "70 €" },
            { name: "Orientación sobre homologación", desc: "Reconocimiento de títulos extranjeros — la complejidad varía, así que primero lo valoramos.", price: "desde 150 €" },
          ],
        },
      ],
    },
    pricingPage: {
      overline: "Precios",
      title: "Precios claros, acordados antes de empezar.",
      sub: "Sin horas que se estiran ni facturas sorpresa. Apruebas el alcance y el precio por escrito antes de que pase nada.",
      promoTitle: "Oferta de bienvenida de septiembre",
      promoText: "50% de descuento en todos los servicios reservados en septiembre — mi forma de decirte bienvenido.",
      promoValid: "Válido para reservas realizadas hasta el 30 de septiembre. El descuento se aplica a todos los servicios y packs.",
      packagesTitle: "Packs — la mejor opción",
      alaCarteTitle: "Servicios individuales",
      pkg1Name: "Primeros 90 días en España",
      pkg1Desc: "El aterrizaje completo: NIE o TIE, empadronamiento, cuenta bancaria y tarjeta sanitaria. Un precio fijo, una persona encargándose de todo.",
      pkg1Includes: ["Apoyo para NIE o TIE", "Alta de empadronamiento", "Apertura de cuenta bancaria", "Alta de tarjeta sanitaria"],
      pkg1Price: "350 €",
      pkg1Note: "frente a ~450 € por separado — ahorra ~100 €",
      pkg2Name: "Instalándote — retainer",
      pkg2Desc: "Tres meses teniéndome a mano. Hasta 5 horas de apoyo al mes para lo que España te vaya poniendo delante: cartas, llamadas, citas, traducciones.",
      pkg2Includes: ["Hasta 5 horas de apoyo / mes", "Respuestas prioritarias por WhatsApp", "Traducción de documentos incluida", "Acompañamiento a citas incluido"],
      pkg2Price: "300 €",
      pkg2Note: "al mes · compromiso de 3 meses",
      cta: "Reservar — oferta de septiembre",
      bookCta: "Reservar",
      bestValue: "Mejor valor",
      tableHeaders: { service: "Servicio", price: "Precio" },
    },
    faqPage: {
      overline: "Preguntas frecuentes",
      title: "Las preguntas que todo el mundo hace.",
      sub: "Respuestas directas en lenguaje claro. Si la tuya no está aquí, pregúntame directamente.",
      items: [
        { q: "¿Cuánto tarda el NIE en Valencia?", a: "El número de NIE suele asignarse en la propia cita o en unos días. El verdadero cuello de botella es la cita previa: en Valencia puede tardar desde unos días hasta varias semanas en aparecer, según la oficina y la época del año. Reservar pronto y mirar las oficinas adecuadas marca la diferencia — y es exactamente lo que hago por ti." },
        { q: "¿Necesito el empadronamiento antes de abrir una cuenta bancaria?", a: "No siempre. Algunos bancos abren cuentas de no residente solo con pasaporte y NIE. Aun así, el certificado de empadronamiento lo facilita todo — lo piden los bancos, la sanidad y los colegios — así que suele recomendarse hacerlo pronto. Es rápido cuando el papeleo está bien." },
        { q: "¿Qué diferencia hay entre el NIE y el TIE?", a: "El NIE es solo un número: tu número de identificación de extranjero, usado para impuestos, contratos y trámites. El TIE es la tarjeta física de residencia para ciudadanos no comunitarios de larga duración; incluye tu NIE, foto, huellas y tipo de permiso. Los ciudadanos de la UE suelen recibir el certificado verde. Gestiono ambos procesos." },
        { q: "¿Puedes conseguirme la cita previa?", a: "Sí — es uno de mis servicios más solicitados (35 €). Las citas de policía, extranjería y ayuntamientos en Valencia desaparecen en minutos cuando se publican. Vigilo el sistema y consigo una para ti, y luego te envío la confirmación y la lista exacta de lo que debes llevar." },
        { q: "¿Ofreces traducción jurada?", a: "No — soy traductora e intérprete profesional, pero no traductora jurada acreditada (Traductora-Intérprete Jurada). Documentos como certificados de nacimiento para uso oficial en registros requieren por ley una traducción jurada, y para esos te pondré en contacto con una colega acreditada de confianza. Para todo lo demás — contratos, cartas, documentos cotidianos e interpretación en persona — puedo ayudarte directamente." },
        { q: "¿Tengo que estar en Valencia para trabajar contigo?", a: "No. Trabajo en persona por toda la Comunidad Valenciana — Valencia capital, Alicante, Xàbia/Jávea, Dénia, Gandía y alrededores — y online con clientes de toda España. Muchas cosas (preparación de documentos, traducción, reserva de citas) pueden hacerse completamente a distancia." },
        { q: "¿Cómo funciona la oferta de septiembre?", a: "Cualquier servicio reservado antes del 30 de septiembre tiene un 50% de descuento sobre el precio de lista — incluidos los packs. Escríbeme por WhatsApp o por el formulario, menciona la oferta y te confirmaré el precio con descuento por escrito antes de empezar." },
        { q: "¿Qué documentos necesito para el empadronamiento en Valencia?", a: "Normalmente tu pasaporte, tu NIE (si lo tienes) y un justificante de domicilio: contrato de alquiler o autorización firmada por el propietario junto con su documentación. Los requisitos varían ligeramente según el ayuntamiento, así que compruebo la lista exacta para tu dirección antes de ir." },
        { q: "¿Puedes ayudarme a darme de alta como autónomo en España?", a: "Sí. El alta implica registrarse en Hacienda y en la Seguridad Social, elegir el epígrafe correcto y entender tus opciones de cuota — incluida la tarifa reducida para nuevos autónomos. La puesta en marcha completa cuesta 150 €, y si quieres también puedo coordinar con un gestor para tus declaraciones periódicas." },
        { q: "¿Esto es asesoramiento legal o fiscal?", a: "No. Te ayudo a navegar los trámites, preparar documentos y comunicarte con las oficinas. Para asesoramiento legal o fiscal formal te derivaré con un abogado o gestor de confianza — y traduciré y coordinaré con ellos para que nada se pierda." },
      ],
      cta: "Pregúntame directamente",
    },
    contactPage: {
      overline: "Contacto",
      title: "Vamos a resolverlo.",
      sub: "WhatsApp es lo más rápido — suelo responder en pocas horas. O envía el formulario y te contesto por email.",
      whatsapp: "WhatsApp (preferido)",
      emailLabel: "Email",
      phoneLabel: "Teléfono",
      areaTitle: "Zona de servicio",
      areaSub: "En persona por toda la Comunidad Valenciana · online en toda España",
      form: {
        name: "Tu nombre",
        email: "Tu email",
        topic: "¿En qué necesitas ayuda?",
        message: "Cuéntame un poco tu situación",
        messagePlaceholder: "p. ej. Acabo de llegar a Valencia y necesito el NIE y el empadronamiento…",
        topics: ["NIE / TIE / residencia", "Empadronamiento / seguridad social", "Alta de autónomo", "Traducción / interpretación", "Vivienda / suministros", "Banca / impuestos", "Salud", "Colegios / familia", "Un pack", "Otra cosa"],
        sendEmail: "Enviar por email",
        sendWhatsapp: "Enviar por WhatsApp",
        note: "El formulario abre tu app de email o WhatsApp con el mensaje listo — nada se guarda en esta web.",
        nameRequired: "Añade tu nombre y tu mensaje primero, por favor.",
      },
    },
    blog: {
      overline: "Blog",
      title: "Apuntes para moverse por España.",
      sub: "Recorridos en lenguaje claro por los trámites que gestiono cada semana — guías nuevas con regularidad.",
      soon: "Próximamente",
      topics: [
        { title: "El NIE en Valencia: la guía completa 2026", tag: "Trámites" },
        { title: "Empadronamiento: qué es y por qué te lo piden para todo", tag: "Instalarse" },
        { title: "NIE, TIE o certificado verde: ¿cuál te toca a ti?", tag: "Residencia" },
        { title: "Autónomo en España: los primeros 30 días, paso a paso", tag: "Trabajar" },
        { title: "Cómo funciona de verdad la cita previa (y cómo conseguirla)", tag: "Trámites" },
        { title: "Alquilar en Valencia: lo que tu contrato dice de verdad", tag: "Vivienda" },
      ],
      cta: "Avísame por WhatsApp",
    },
    footer: {
      tagline: "La burocracia en España, resuelta con calma — en tu idioma.",
      nav: "Explorar",
      contactTitle: "Contacto",
      area: "Valencia · Comunidad Valenciana · online en toda España",
      rights: "Todos los derechos reservados.",
      madeIn: "Valencia, España",
    },
  },
};
